/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import ZeroIcon from "@/src/assets/icons/traffic/toggleable/IconLicencePointsZero";
import ThreeIcon from "@/src/assets/icons/traffic/toggleable/IconLicensePointsOneToThree";
import EightIcon from "@/src/assets/icons/traffic/toggleable/IconLicensePointsFourToEight";
import QuestionIcon from "@/src/assets/icons/common/toggleable/IconQuestionmark";
import { useForm } from "@/src/provider/Form/FormProvider";
import Group from "@/src/components/Wizard/Group";
import { requiredValidator } from "@/src/services/validationRules";
import Typography from "@mui/material/Typography";
import { translate } from "@/src/services/translations/translations";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { FormDataTypes } from "@/src/types/FormDataTypes";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

export default function Flensburg({ submitProps }: { submitProps: FormSubmitProps }) {
  const { handleSubmit, values }: FormDataTypes = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Verstoß
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type="radio"
                name="flensburgPoints"
                question={translate("traffic.flensburgPoints.label", values)}
                options={[
                  {
                    labelText: translate("traffic.flensburgPoints.options.none.label", values),
                    labelIcon: <ZeroIcon />,
                    labelIconActive: <ZeroIcon active />,
                    value: "none",
                  },
                  {
                    labelText: translate("traffic.flensburgPoints.options.1-3.label", values),
                    labelIcon: <ThreeIcon />,
                    labelIconActive: <ThreeIcon active />,
                    value: "1-3",
                  },
                  {
                    labelText: translate("traffic.flensburgPoints.options.4-8.label", values),
                    labelIcon: <EightIcon />,
                    labelIconActive: <EightIcon active />,
                    value: "4-8",
                  },
                  {
                    labelText: translate("traffic.flensburgPoints.options.unknown.label", values),
                    labelIcon: <QuestionIcon />,
                    labelIconActive: <QuestionIcon active />,
                    value: "unknown",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
